import { taskFileThumbnailTypeDef } from "../../taks-file/definitions/task-file-thumbnail-type-def";

export const taskCalculationFileTypeDef = `
    id
    taskId
    name
    size
    extension
    createdAt
    updatedAt
    removedAt
    type
    src
    thumbnails {
      ${taskFileThumbnailTypeDef}
    }
`;
